import { confirm, toast } from '@gitbook/spine-react';
import { useEventCallback } from '@gitbook/util-react-hooks';

import { apiClient } from '../../../../../state';

export function useSiteUnpublish(organizationId: string, siteId: string) {
    return useEventCallback(() => {
        void confirm({
            title: 'Unpublish site?',
            description:
                'Your site will no longer be available to external audiences. You can republish your site with the same URL at any time.',
            kind: 'danger',
            confirmLabel: 'Unpublish',
            onConfirm: async (_event, { preventClose }) => {
                await toast.catch(
                    async () => {
                        await apiClient.sites.unpublishSite(organizationId, siteId);
                        toast.success('Site unpublished');
                    },
                    'Error while unpublishing site',
                    { onReject: preventClose }
                );
            },
        });
    });
}
